// Na een update van Bladwijzer hebben de stukken van de app nieuwe namen (scripts/build.js). Een pagina van de vorige
// versie (een open tabblad, of een pagina uit een cache tussen de bezoeker en de server), of een stuk dat tijdens het
// wisselen van versie nog bij de oude server terechtkomt, vindt een stuk dan niet meer (“Failed to fetch dynamically
// imported module”). Dan halen we de pagina opnieuw op met een uniek adres (?_v=…), zodat geen enkele cache de oude
// pagina teruggeeft: de eerste keer meteen, daarna na een paar seconden (de nieuwe versie staat soms nog niet overal),
// hooguit drie keer per pagina binnen vijf minuten. Lukt het dan nog niet, dan toont de app een duidelijke melding.
const KEY = 'bw-reload';
const PARAM = '_v';
const MAX = 3;
const WINDOW = 5 * 60_000;

function readCount() {
  try {
    const old = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (old && old.path === location.pathname && Date.now() - old.at < WINDOW) return old;
  } catch { /* geen opslag, of een oude waarde */ }
  return { path: location.pathname, n: 0, at: Date.now() };
}

/**
 * Een stuk van de app laadde niet: de pagina opnieuw ophalen. Geeft false als dat voor deze pagina al te vaak gebeurde
 * (dan toont de app de fout), anders true (en de pagina herlaadt).
 */
export function reloadFresh() {
  const count = readCount();
  if (count.n >= MAX) return false;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ...count, n: count.n + 1 }));
  } catch {
    // Zonder opslag kunnen we niet tellen: enkel als de pagina nog niet opnieuw opgehaald werd.
    if (new URLSearchParams(location.search).has(PARAM)) return false;
  }
  const url = new URL(location.href);
  url.searchParams.set(PARAM, Date.now().toString(36));
  setTimeout(() => location.replace(url.href), count.n ? 2000 * count.n : 0);
  return true;
}

/** Een scherm laadde: de teller weer op nul. */
export function reloadDone() {
  try {
    sessionStorage.removeItem(KEY);
  } catch { /* geen opslag */ }
}

/** Bij het starten: ?_v= weer uit het adres (voor de bezoeker, de statistieken en een gedeelde link). */
export function stripReloadParam() {
  const url = new URL(location.href);
  if (!url.searchParams.has(PARAM)) return;
  url.searchParams.delete(PARAM);
  history.replaceState(history.state, '', url.pathname + url.search + url.hash);
}
